import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Copyright from '../common/Copyright';
import BasicData from './BasicData';
import Description from './Description';
import { AreaForm } from '../../models/area.model';
import MainContainer from '../common/MainContainer';
import FormSection, { FormConfirm, FormElement } from '../common/FormSection';
import AlertMessage from '../common/AlertMessage';
import ActionButton from '../common/ActionButton';
import { getCompanies } from '../../services/autocomplete.service';
import { itemSelection } from '../../models/itemSelection.model';
import Notifications from './Notifications';
import { useNotification } from '../../context/NotificationContext';


interface HandleFormProps {
  action: string
  handleChange?: (e: any) => void
  handleSelection?: (k: any, v: any) => void
  onSubmit: (p: any) => void
  areaForm: any
  setBlockScreen: (p: boolean) => void
  selectedProject: string
}

export default function HandleForm({
  action,
  setBlockScreen,
  handleChange,
  handleSelection,
  onSubmit,
  areaForm,
  selectedProject }: HandleFormProps) {

  const { handleSubmit } = useForm<AreaForm>()
  const { showNotification } = useNotification();
  const [companiesList, setCompaniesList] = useState<itemSelection[]>([]);

  const requiredFields = [
    'name',
    'company'
  ]

  const formValidator = () => {
    return requiredFields.some((key) => !areaForm[key] || !(areaForm[key]?.id !== '') || Object.keys(areaForm[key]).length === 0)
  }

  const initComponent = () => {
    if (action === "create" || action === 'edit') {
      setBlockScreen(true)
      Promise.all([getCompanies(selectedProject)
      ]).then(function (result) {
        setCompaniesList(result[0])
        setBlockScreen(false)
      }).catch((error) => {
        showNotification(error.response.data)
        setBlockScreen(false)
      });
    }
  }

  useEffect(initComponent, [action])

  return (
    <React.Fragment>
      <MainContainer>
        <FormSection>
          <FormElement>
            <BasicData
              action={action}
              handleChange={handleChange}
              handleSelection={handleSelection}
              companiesList={companiesList}
              areaForm={areaForm}
            />
          </FormElement>

          <FormElement>
            <Notifications
              action={action}
              handleSelection={handleSelection}
              areaForm={areaForm}
            />
          </FormElement>

          <FormElement>
            <Description action={action}
              handleChange={handleChange}
              areaForm={areaForm}
            />
          </FormElement>

          {(action === 'create' || action === 'edit') && (

            <FormConfirm>
              <div className='text-secondary'>
                <p>
                  (*) Campos requeridos
                </p>
              </div>

              {(formValidator()) && (
                <div>
                  <AlertMessage
                    severity="error"
                    message='Hay campos requeridos sin completar' />
                </div>
              )}

              <div>
                <ActionButton
                  text="Confirmar"
                  type="confirm"
                  onClick={handleSubmit(onSubmit)}
                  disabled={formValidator()}
                />
              </div>

            </FormConfirm>
          )}
        </FormSection>
      </MainContainer>
      <Copyright />
    </React.Fragment >
  );
}
